// Dashboard labels for the enums in contracts/notification-delivery.openapi.yaml @ v1.
// Labels are owned by the dashboard; adding or renaming a value is a contract change.

export const NOTIFICATION_TYPE_LABELS = {
  session_reminder_one_hour: 'Pengingat sesi 1 jam',
  session_reminder_thirty_min: 'Pengingat sesi 30 menit',
  session_started: 'Sesi dimulai',
  session_meeting_link_missing: 'Link meeting belum diisi',
  session_meeting_link_set: 'Link meeting diisi',
  session_rescheduled: 'Sesi dijadwalkan ulang',
  session_canceled: 'Sesi dibatalkan',
  session_change_proposed: 'Usulan perubahan jadwal',
  session_change_resolved: 'Hasil usulan perubahan jadwal',
  session_reschedule_paid: 'Reschedule berbayar berhasil',
  admin_session_resolution_completed: 'Resolusi sesi oleh admin',
  mentor_no_show_claim_approved: 'Klaim mentor tidak hadir disetujui',
  mentor_no_show_claim_rejected: 'Klaim mentor tidak hadir ditolak',
  mentor_no_show_claim_confirmed: 'Mentor tidak hadir dikonfirmasi',
  instant_booking_accepted: 'Booking instan diterima',
  instant_booking_declined: 'Booking instan ditolak',
  instant_booking_canceled: 'Booking instan dibatalkan',
  mentoring_scheduled: 'Sesi mentoring baru dijadwalkan',
  payment_success_buyer: 'Pembayaran berhasil (pembeli)',
  payment_received_admin: 'Pembayaran diterima (admin)',
  payment_expired_buyer: 'Pembayaran kedaluwarsa',
  balance_released: 'Saldo masuk',
  balance_deducted: 'Saldo dipotong',
  session_payout: 'Pembayaran sesi ke mentor',
  withdrawal_requested_admin: 'Permintaan penarikan saldo (admin)',
  withdrawal_completed: 'Penarikan saldo selesai',
  email_verification: 'Verifikasi email',
  password_reset: 'Reset password',
  admin_password_reset: 'Reset password admin',
} as const;

export const DELIVERY_STATUS_LABELS = {
  pending: 'Menunggu',
  sent: 'Terkirim',
  failed: 'Gagal',
  skipped: 'Dilewati',
} as const;

export const CHANNEL_LABELS = {
  in_app: 'In-app',
  email: 'Email',
  whatsapp: 'WhatsApp',
} as const;

export const RECIPIENT_KIND_LABELS = {
  user: 'User',
  mentor: 'Mentor',
  admin: 'Admin',
  external: 'Alamat eksternal',
} as const;

/** `admin` is shown as "Admin (<name>)"; see getAttemptTriggerLabel. */
export const ATTEMPT_TRIGGER_LABELS = {
  system: 'Sistem',
  automatic_retry: 'Retry otomatis',
  admin: 'Admin',
} as const;

export const SECRET_BEARING_CONTENT_NOTE =
  'Isi notifikasi ini tidak disimpan karena berisi tautan rahasia.';

export const SKIPPED_NOTE = 'Penerima tidak punya alamat untuk channel ini.';

export type NotificationType = keyof typeof NOTIFICATION_TYPE_LABELS;
export type DeliveryStatus = keyof typeof DELIVERY_STATUS_LABELS;
export type Channel = keyof typeof CHANNEL_LABELS;
export type RecipientKind = keyof typeof RECIPIENT_KIND_LABELS;

/**
 * Looks up the dashboard label for an enum value. Values the contract may add
 * later are shown raw instead of crashing.
 */
export function getLabel(labels: Record<string, string>, value: string) {
  return Object.hasOwn(labels, value) ? labels[value] : value;
}
